module.exports = __webpack_public_path__ + "img/dev2.ebf0877d.jpg";